<section class="agpr-deliveryScheduler">
  <ng-container *ngIf="deliverySchedulingTypes">
    <div class="agpr-deliveryScheduler-schedulingTypes" *ngIf="minDate <= today">
      <div class="agpr-deliveryScheduler-schedulingType">
        <agpr-radio
          [id]="inputId + '-immediateRadioButton'"
          name="schedule-urgency-{{id}}"
          [value]="deliverySchedulingTypes.immediate"
          [label]="immediateOptionLabel"
          [disabled]="disabled || disableSendNow"
          [(ngModel)]="selectedSchedulingType"
          [tooltip]="disabledTooltip"
          (onClick)="schedulingTypeChanged(deliverySchedulingTypes.immediate)"
          [ariaDescribedBy]=" selectedSchedulingType === deliverySchedulingTypes.immediate ? 'scheduling_time_errors' : ''"
        ></agpr-radio>
      </div>
      <div
        class="agpr-deliveryScheduler-schedulingType"
        role="group"
        [attr.aria-labelledby]="inputId + '-futureRadioButton_radioLabel'"
        [attr.aria-describedby]="'scheduled-delivery-date-errors-' + id"
      >
        <agpr-radio
          [id]="inputId + '-futureRadioButton'"
          name="schedule-urgency-{{id}}"
          [value]="deliverySchedulingTypes.future"
          [label]="futureOptionLabel"
          [disabled]="disabled || disableSendLater"
          [(ngModel)]="selectedSchedulingType"
          [tooltip]="disabledTooltip"
          (onClick)="schedulingTypeChanged(deliverySchedulingTypes.future)"
          [ariaDescribedBy]=" selectedSchedulingType === deliverySchedulingTypes.future ? 'scheduling_time_errors' : ''"
        ></agpr-radio>
        <div
          *ngIf="selectedSchedulingType === deliverySchedulingTypes.future"
          class="agpr-deliveryScheduler-futureDateSelector"
          @containerState
        >
          <div
            class="agpr-deliveryScheduler-date ui-fluid"
          >
            <span [id]="inputId + '_format'" class="u-srOnly">{{ 'date' | localize }}. {{ 'dateFormat' | localize }}</span>
            <div class="agpr-inputOverlay">
              <agpr-date-picker
                #calendar
                [id]="inputId + '_deliveryScheduler_datePicker'"
                [minDate]="minDate"
                [readonlyInput]]="disabled"
                [ariaLabelledBy]="inputId + '_format'"
                [(ngModel)]="calendarDate"
                (blur)="debouncedUpdateDeliveryDate()"
                (select)="debouncedUpdateDeliveryDate()"
              ></agpr-date-picker>
            </div>
          </div>
          <div
            class="agpr-deliveryScheduler-time"
            [ngClass]="{
              'agpr-deliveryScheduler-time--active': isFutureDateSelectorEnabled()
            }"
          >
            <ng-container *ngIf="time">
              <agpr-time-picker
                [id]="inputId + '-updateDeliveryDate'"
                hourDescribedBy="scheduled-delivery-date-errors-{{id}}"
                minuteDescribedBy="scheduled-delivery-date-errors-{{id}}"
                [infoIconStyleClass]="infoIconStyleClass"
                [infoTooltipStyleClass]="infoTooltipStyleClass"
                [disabled]="disabled"
                [(ngModel)]="time"
                (changeTimeZone)="updateDeliveryDate()"
                (changeHour)="updateDeliveryDate()"
                (changeMinute)="updateDeliveryDate()"
                (changeMeridian)="updateDeliveryDate()"
              ></agpr-time-picker>
              <ul
                *ngIf="!disabled"
                id="scheduled-delivery-date-errors-{{id}}"
                class="agpr-deliveryScheduler-validationMessages"
              >
                <li *ngFor="let error of errors">
                  <agpr-form-message>
                    {{ error.summary }}
                  </agpr-form-message>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div
      class="agpr-deliveryScheduler-schedulingType"
      *ngIf="showRecurring"
      role="group"
      [attr.aria-labelledby]="inputId + '-recurringRadioButton_radioLabel'"
      [attr.aria-describedby]="'recurring-delivery-date-errors-' + id"
    >
      <agpr-radio
        [id]="inputId + '-recurringRadioButton'"
        name="schedule-urgency-{{id}}"
        [value]="deliverySchedulingTypes.recurring"
        [label]="recurringOptionLabel"
        [disabled]="disabled"
        [(ngModel)]="selectedSchedulingType"
        (onClick)="schedulingTypeChanged(deliverySchedulingTypes.recurring)"
        [ariaDescribedBy]=" selectedSchedulingType === deliverySchedulingTypes.recurring ? 'scheduling_time_errors' : ''"
      ></agpr-radio>
      <div
        *ngIf="selectedSchedulingType === deliverySchedulingTypes.recurring"
        class="agpr-deliveryScheduler-recurringPatternSelector"
        @containerState
      >
        <div
          role="group"
          [attr.aria-labelledby]="inputId + '-recurringDailyRadioButton_radioLabel'"
          [attr.aria-describedby]="'recurring-delivery-date-errors-' + id"
        >
          <agpr-radio
            name="recurring-details-{{id}}"
            [id]="inputId + '-recurringDailyRadioButton'"
            [value]="deliveryRecurrenceFrequencyEnum.daily"
            label="DeliveryScheduler.input.daily"
            [(ngModel)]="recurringModel.frequencyType"
            (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.daily)"
          >
          </agpr-radio>
          <div
            class="agpr-deliveryScheduler-recurringPatternSelectorDetails"
            *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.daily"
            @containerState
          >
            <agpr-multi-time-picker
              [id]="inputId + '-recurringDaily-timeSelector'"
              hourDescribedBy="recurring-delivery-date-errors-{{id}}"
              minuteDescribedBy="recurring-delivery-date-errors-{{id}}"
              [infoIconStyleClass]="infoIconStyleClass"
              [infoTooltipStyleClass]="infoTooltipStyleClass"
              [(ngModel)]="recurringMultiTimes"
              (ngModelChange)="updateRecurringPattern()"
              [showTimeZoneSelector]="true"
            >
            </agpr-multi-time-picker>
          </div>
        </div>
        <div
          role="group"
          [attr.aria-labelledby]="inputId + '-recurringWeeklyRadioButton_radioLabel'"
          [attr.aria-describedby]="'recurring-delivery-date-errors-' + id"
        >
          <agpr-radio
            name="recurring-details-{{id}}"
            [id]="inputId + '-recurringWeeklyRadioButton'"
            [value]="deliveryRecurrenceFrequencyEnum.weekly"
            label="DeliveryScheduler.input.weekly"
            [(ngModel)]="recurringModel.frequencyType"
            (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.weekly)"
          >
          </agpr-radio>
          <div
            class="agpr-deliveryScheduler-recurringPatternSelectorDetails"
            *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.weekly"
            @containerState
          >
            <agpr-multi-select-dropdown
              [id]="inputId + '-recurringWeekly-weekdaySelector'"
              [(ngModel)]="recurringModel.frequencyValues"
              (ngModelChange)="updateRecurringPattern()"
              [optionsList]="daysOfTheWeek"
              [placeholder]="'Common.forms.deliveryScheduler.weekDayPlaceholder' | localize"
              ariaLabel="weekdaySelection"
            ></agpr-multi-select-dropdown>

            <agpr-time-picker
              [id]="inputId + '-recurringWeekly-timeSelector'"
              hourDescribedBy="recurring-delivery-date-errors-{{id}}"
              minuteDescribedBy="recurring-delivery-date-errors-{{id}}"
              [infoIconStyleClass]="infoIconStyleClass"
              [infoTooltipStyleClass]="infoTooltipStyleClass"
              [(ngModel)]="recurringTime"
              [showTimeZoneSelector]="true"
              (changeTimeZone)="updateRecurringPattern()"
              (changeHour)="updateRecurringPattern()"
              (changeMinute)="updateRecurringPattern()"
              (changeMeridian)="updateRecurringPattern()"
            ></agpr-time-picker>
          </div>
        </div>

        <div
          role="group"
          [attr.aria-labelledby]="inputId + '-recurringMonthlyRadioButton' + '_radioLabel'"
          [attr.aria-describedby]="'recurring-delivery-date-errors-' + id"
        >
          <agpr-radio
            name="recurring-details-{{id}}"
            [id]="inputId + '-recurringMonthlyRadioButton'"
            [value]="deliveryRecurrenceFrequencyEnum.monthly"
            label="DeliveryScheduler.input.monthly"
            [(ngModel)]="recurringModel.frequencyType"
            (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.monthly)"
          >
          </agpr-radio>
          <div
            class="agpr-deliveryScheduler-recurringPatternSelectorDetails"
            *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.monthly"
            @containerState
          >
            <agpr-multi-select-dropdown
              [id]="inputId + '-recurringMonthly-dateSelector'"
              [(ngModel)]="recurringModel.frequencyValues"
              (ngModelChange)="updateRecurringPattern()"
              [optionsList]="daysOfTheMonthOptions"
              [placeholder]="'Common.forms.deliveryScheduler.monthDayPlaceholder' | localize"
              ariaLabel="dateSelection"
            ></agpr-multi-select-dropdown>

            <agpr-time-picker
              [id]="inputId + '-recurringMonthly-timeSelector'"
              hourDescribedBy="recurring-delivery-date-errors-{{id}}"
              minuteDescribedBy="recurring-delivery-date-errors-{{id}}"
              [infoIconStyleClass]="infoIconStyleClass"
              [infoTooltipStyleClass]="infoTooltipStyleClass"
              [(ngModel)]="recurringTime"
              [showTimeZoneSelector]="true"
              (changeTimeZone)="updateRecurringPattern()"
              (changeHour)="updateRecurringPattern()"
              (changeMinute)="updateRecurringPattern()"
              (changeMeridian)="updateRecurringPattern()"
            ></agpr-time-picker>
          </div>
        </div>

        <div
          role="group"
          [attr.aria-labelledby]="inputId + '-recurringQuarterlyRadioButton' + '_radioLabel'"
          [attr.aria-describedby]="'recurring-delivery-date-errors-' + id"
        >
          <div class="agpr-deliveryScheduler-recurringQuarterlyOption">
            <agpr-radio
              name="recurring-details-{{id}}"
              [id]="inputId + '-recurringQuarterlyRadioButton'"
              [value]="deliveryRecurrenceFrequencyEnum.quarterly"
              label="DeliveryScheduler.input.quarterly"
              [(ngModel)]="recurringModel.frequencyType"
              (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.quarterly)"
            >
            </agpr-radio>
            <span
              [id]="inputId + '-recurringQuarterlyInfo'"
              class="fa-regular fa-circle-info agpr-deliveryScheduler-recurringQuarterlyInfo"
              [agprTooltip]="'DeliveryScheduler.input.quarterly.tooltip'"
            ></span>
          </div>
          <div
            class="agpr-deliveryScheduler-recurringPatternSelectorDetails"
            *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.quarterly"
            @containerState
          >
            <agpr-timezone-picker
              [id]="inputId + '-recurringQuarterly-timeZoneSelector'"
              [(ngModel)]="recurringTime.timeZone"
              (ngModelChange)="updateRecurringPattern()"
              [defaultToUserPreference]="true"
            ></agpr-timezone-picker>
          </div>
        </div>

        <ul
          *ngIf="!disabled"
          id="recurring-delivery-date-errors-{{id}}"
          class="agpr-deliveryScheduler-validationMessages"
        >
          <li *ngFor="let error of errors">
            <agpr-form-message>
              {{ error.summary }}
            </agpr-form-message>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</section>
